import React from "react";
import css from "./index.module.scss";
import { useInView, animated } from "@react-spring/web";
import { useTranslation } from "react-i18next";

function Index() {
  const { t } = useTranslation();

  const [firtstRef, firstRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );

  const [secondRef, secondRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );

  const [thirdRef, thirdRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );

  return (
    <div className={css.posContain}>
      <div className={css.maintitle}>{t("POS-MIS")}</div>
      <div className={css.secondtitle}>{t("$singlee_posmis1")}</div>

      <div className={`${css.subtitle} ${css.none}`}>
        {t("POS-MIS和单体POS的对比")}
      </div>
      <div className={css.first} ref={firtstRef}>
        <animated.div className={css.contentBox} style={firstRefStyle}>
          <div className={css.table}>
            <div className={css.line}>
              <div className={css.topleft}>{t("单体POS")}</div>
              <div className={css.topright}>{t("POS-MIS")}</div>
            </div>
            <div className={css.line}>
              <div className={css.left}>
                <div className={css.item}>
                  <div>{t("$singlee_posmis2")}</div>
                </div>
              </div>
              <div className={css.right}>
                <div className={css.item}>
                  <div>{t("$singlee_posmis5")}</div>
                  <div>{t("$singlee_posmis6")}</div>
                </div>
              </div>
            </div>
            <div className={css.line}>
              <div className={css.left}>
                <div className={css.item}>
                  <div>{t("$singlee_posmis3")}</div>
                </div>
              </div>
              <div className={css.right}>
                <div className={css.item}>
                  <div>{t("$singlee_posmis7")}</div>
                  <div>{t("$singlee_posmis8")}</div>
                </div>
              </div>
            </div>
            <div className={css.line}>
              <div className={css.left}>
                <div className={css.item}>
                  <div>{t("$singlee_posmis4")}</div>
                </div>
              </div>
              <div className={css.right}>
                <div className={css.item}>
                  <div>{t("$singlee_posmis9")}</div>
                </div>
              </div>
            </div>
            <div className={css.line}>
              <div className={css.left}></div>
              <div className={css.right}>
                <div className={css.item} style={{ borderBottom: "none" }}>
                  <div>{t("$singlee_posmis10")}</div>
                  <div>{t("$singlee_posmis11")}</div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className={css.left}>
            <div className={css.top}>{t("单体POS")}</div>
            <div className={css.bot}>
              <div
                className={css.item}
                style={{
                  height:
                    ref1.current && ref1.current.getBoundingClientRect().height,
                }}
              >
                <div>{t("$singlee_posmis2")}</div>
              </div>
              <div
                className={css.item}
                style={{
                  height:
                    ref2.current && ref2.current.getBoundingClientRect().height,
                }}
              >
                <div>{t("$singlee_posmis3")}</div>
              </div>
              <div className={css.item} ref={ref3}>
                <div>{t("$singlee_posmis4")}</div>
              </div>
              <div
                className={css.item}
                style={{
                  height:
                    ref4.current && ref4.current.getBoundingClientRect().height,
                }}
              ></div>
            </div>
          </div>
          <div className={css.right}>
            <div className={css.top}>{t("POS-MIS")}</div>
            <div className={css.bot}>
              <div className={css.item} ref={ref1}>
                <div>{t("$singlee_posmis5")}</div>
                <div>{t("$singlee_posmis6")}</div>
              </div>
              <div className={css.item} ref={ref2}>
                <div>{t("$singlee_posmis7")}</div>
                <div>{t("$singlee_posmis8")}</div>
              </div>
              <div
                className={css.item}
                style={{
                  height:
                    ref3.current && ref3.current.getBoundingClientRect().height,
                }}
              >
                <div>{t("$singlee_posmis9")}</div>
              </div>
              <div className={css.item} ref={ref4}>
                <div>{t("$singlee_posmis10")}</div>
                <div>{t("$singlee_posmis11")}</div>
              </div>
            </div>
          </div> */}
        </animated.div>
      </div>

      <div className={css.subtitle}>{t("适用场景")}</div>
      <div className={css.second} ref={secondRef}>
        <animated.div className={css.inner} style={secondRefStyle}>
          <div className={css.content}>
            <div className={css.left}>
              <div className={css.text}>{t("$singlee_posmis12")}</div>
            </div>
            <div className={css.right}>
              <div className={css.text}>{t("$singlee_posmis12")}</div>
            </div>
          </div>
        </animated.div>
      </div>

      <div className={css.subtitle}>{t("部分合作案例")}</div>
      <div className={css.third} ref={thirdRef}>
        <animated.div className={css.inner} style={thirdRefStyle}>
          <div className={css.box}>
            <div className={css.each}>{t("SKP")}</div>
            <div className={css.each}>{t("$singlee_posmis_ql")}</div>
            <div className={css.each}>{t("$singlee_posmis_wf")}</div>
            <div className={css.each}>{t("$singlee_posmis_oy")}</div>
            <div className={css.each}>{t("$singlee_posmis_zg")}</div>
            <div className={css.each}>{t("$singlee_posmis_lf")}</div>
            <div className={css.each}>{t("$singlee_posmis_hz")}</div>
            <div className={css.each}>{t("$singlee_posmis_hs")}</div>
            <div className={css.each}>{t("$singlee_posmis_yh")}</div>
            <div className={css.each}>{t("$singlee_posmis_ly")}</div>
          </div>
        </animated.div>
      </div>
    </div>
  );
}

export default React.memo(Index);
